import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './components/ui/Toast';
import ModernAuthenticator from './components/auth/ModernAuthenticator';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ModernDashboard from './pages/ModernDashboard';
import ModernDomainsPage from './pages/ModernDomainsPage';
import Links from './pages/Links';
import Analytics from './pages/Analytics';
import ModernProfile from './pages/ModernProfile';
import CleanLayout from './components/layout/CleanLayout';
import RedirectPage from './components/public/RedirectPage';
import ShortLinkRedirect from './components/redirect/ShortLinkRedirect';
import MainRedirect from './components/public/MainRedirect';
import Fun404Page from './components/public/Fun404Page';
import EditLinkPage from './pages/EditLinkPage';

console.log('🔧 App Environment Check:');
console.log('REACT_APP_ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('isDemoMode should be:', process.env.REACT_APP_ENVIRONMENT !== 'production');

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <Router>
              <Routes>
                {/* Public redirect routes - NO authentication required */}
                <Route path="/r/:shortCode" element={<RedirectPage />} />

                {/* Short link routes - NO authentication required */}
                <Route path="/:shortCode" element={<ShortLinkRedirect />} />

                {/* Root domain - domain-aware redirect */}
                <Route path="/" element={<MainRedirect />} />

                {/* Admin routes - require authentication */}
                <Route
                  path="/admin"
                  element={
                    <ModernAuthenticator>
                      <CleanLayout>
                        <ProtectedRoute>
                          <ModernDashboard />
                        </ProtectedRoute>
                      </CleanLayout>
                    </ModernAuthenticator>
                  }
                />
                <Route
                  path="/admin/domains"
                  element={
                    <ModernAuthenticator>
                      <CleanLayout>
                        <ProtectedRoute>
                          <ModernDomainsPage />
                        </ProtectedRoute>
                      </CleanLayout>
                    </ModernAuthenticator>
                  }
                />
                <Route
                  path="/admin/links"
                  element={
                    <ModernAuthenticator>
                      <CleanLayout>
                        <ProtectedRoute>
                          <Links />
                        </ProtectedRoute>
                      </CleanLayout>
                    </ModernAuthenticator>
                  }
                />
                <Route
                  path="/admin/analytics"
                  element={
                    <ModernAuthenticator>
                      <CleanLayout>
                        <ProtectedRoute>
                          <Analytics />
                        </ProtectedRoute>
                      </CleanLayout>
                    </ModernAuthenticator>
                  }
                />
                <Route
                  path="/admin/profile"
                  element={
                    <ModernAuthenticator>
                      <CleanLayout>
                        <ProtectedRoute>
                          <ModernProfile />
                        </ProtectedRoute>
                      </CleanLayout>
                    </ModernAuthenticator>
                  }
                />
                <Route
                  path="/admin/links/:linkId/edit"
                  element={
                    <ModernAuthenticator>
                      <CleanLayout>
                        <ProtectedRoute>
                          <EditLinkPage />
                        </ProtectedRoute>
                      </CleanLayout>
                    </ModernAuthenticator>
                  }
                />

                {/* Catch-all 404 */}
                <Route path="*" element={<Fun404Page />} />
              </Routes>
            </Router>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;